import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';

const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(4),
  },
  title: {},
  subtitle: {
    marginTop: theme.spacing(2),
  },
});

const Header = ({
  className,
  classes,
  title,
  subtitle,
  TitleProps,
  SubtitleProps,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Title
        className={classes.title}
        {...TitleProps}
        value={title}
      />
      {subtitle ? (
        <Subtitle
          className={classes.subtitle}
          {...SubtitleProps}
          value={subtitle}
        />
      ) : null}
    </Box>
  );
};

Header.defaultProps = {
  className: '',
  subtitle: null,
  TitleProps: {},
  SubtitleProps: {},
};

Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  TitleProps: PropTypes.object,
  SubtitleProps: PropTypes.object,
};

export default withStyles(styles)(Header);
